var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10062_11787)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10062_11787",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3911 7.49778H8.89295V10.6068H13.2089C12.8066 12.5819 11.1241 13.7157 8.89295 13.7157C6.25947 13.7157 4.13805 11.5943 4.13805 8.96082C4.13805 6.32734 6.25947 4.20592 8.89295 4.20592C10.0268 4.20592 11.0509 4.60826 11.8556 5.26663L14.1965 2.92575C12.77 1.68216 10.9412 0.914062 8.89295 0.914062C4.43066 0.914062 0.846191 4.49853 0.846191 8.96082C0.846191 13.4231 4.43066 17.0076 8.89295 17.0076C12.9163 17.0076 16.574 14.0815 16.574 8.96082C16.574 8.48533 16.5008 7.97327 16.3911 7.49778Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10062_11787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.113281 13.7149V4.20508L6.33123 8.95998L0.113281 13.7149Z",
    fill: "#FBBC05"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10062_11787",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3911 7.49778H8.89295V10.6068H13.2089C12.8066 12.5819 11.1241 13.7157 8.89295 13.7157C6.25947 13.7157 4.13805 11.5943 4.13805 8.96082C4.13805 6.32734 6.25947 4.20592 8.89295 4.20592C10.0268 4.20592 11.0509 4.60826 11.8556 5.26663L14.1965 2.92575C12.77 1.68216 10.9412 0.914062 8.89295 0.914062C4.43066 0.914062 0.846191 4.49853 0.846191 8.96082C0.846191 13.4231 4.43066 17.0076 8.89295 17.0076C12.9163 17.0076 16.574 14.0815 16.574 8.96082C16.574 8.48533 16.5008 7.97327 16.3911 7.49778Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10062_11787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.113281 4.20502L6.33123 8.95993L8.89157 6.72878L17.6699 5.30231V0.181641H0.113281V4.20502Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10062_11787",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3911 7.49778H8.89295V10.6068H13.2089C12.8066 12.5819 11.1241 13.7157 8.89295 13.7157C6.25947 13.7157 4.13805 11.5943 4.13805 8.96082C4.13805 6.32734 6.25947 4.20592 8.89295 4.20592C10.0268 4.20592 11.0509 4.60826 11.8556 5.26663L14.1965 2.92575C12.77 1.68216 10.9412 0.914062 8.89295 0.914062C4.43066 0.914062 0.846191 4.49853 0.846191 8.96082C0.846191 13.4231 4.43066 17.0076 8.89295 17.0076C12.9163 17.0076 16.574 14.0815 16.574 8.96082C16.574 8.48533 16.5008 7.97327 16.3911 7.49778Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10062_11787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.113281 13.7148L11.0861 5.30231L13.9757 5.66807L17.6699 0.181641V17.7382H0.113281V13.7148Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_10062_11787",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3911 7.49778H8.89295V10.6068H13.2089C12.8066 12.5819 11.1241 13.7157 8.89295 13.7157C6.25947 13.7157 4.13805 11.5943 4.13805 8.96082C4.13805 6.32734 6.25947 4.20592 8.89295 4.20592C10.0268 4.20592 11.0509 4.60826 11.8556 5.26663L14.1965 2.92575C12.77 1.68216 10.9412 0.914062 8.89295 0.914062C4.43066 0.914062 0.846191 4.49853 0.846191 8.96082C0.846191 13.4231 4.43066 17.0076 8.89295 17.0076C12.9163 17.0076 16.574 14.0815 16.574 8.96082C16.574 8.48533 16.5008 7.97327 16.3911 7.49778Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_10062_11787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6693 17.7383L6.33072 8.95998L4.86768 7.8627L17.6693 4.20508V17.7383Z",
    fill: "#4285F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10062_11787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0935,
    height: 16.0935,
    fill: "white",
    transform: "translate(0.588867 0.912109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.8dc140ec06f31cc3dda983002f69c4d6.svg";
export { ForwardRef as ReactComponent };